module.exports = __webpack_public_path__ + "img/ss.1ba14435.svg";